import { Pipe, PipeTransform } from '@angular/core';
import { AssetPathService } from '../services/asset-path.service';

@Pipe({
  name: 'platformasset'
})
export class PlatformassetPipe implements PipeTransform {
  constructor(private assetPathService: AssetPathService) {}

  /**
   * turns e.g images/customer-award.png to https://www.alpy.com/assetz/assets/images/customer-award.png
   * @param relativeUrl the relative path to the asset without 'assets'. Start without slash
   * @param fromAngular is the asset hosted by angular? (assetz) or not?
   * @param platformSpecific if true, will search under the platformspecific subfolder
   */
  transform(relativeUrl: string, fromAngular = false, platformSpecific = false, folder = '/assets/'): string {
    return this.assetPathService.getAssetsPath(relativeUrl, fromAngular, platformSpecific, folder);
  }
}
